// Catálogo de artículos del blog.
// Cada post es un módulo JS que exporta { meta, content } — así ganamos autocompletado
// y podemos hacer imports estáticos sin necesidad de un loader de markdown.

import { post as primerViajeEsquiNinos } from "./posts/primer-viaje-esqui-con-ninos";
import { post as cerlerVsMasella } from "./posts/cerler-vs-masella-familias";
import { post as cuantoCuesta } from "./posts/cuanto-cuesta-viaje-esqui-familia-2027";
import { post as queLlevarMaleta } from "./posts/que-llevar-maleta-esqui-ninos";

export const BLOG_POSTS = [queLlevarMaleta, cuantoCuesta, cerlerVsMasella, primerViajeEsquiNinos];

export const getPostBySlug = (slug) =>
  BLOG_POSTS.find((p) => p.meta.slug === slug);

export const getRecentPosts = (limit = 6, excludeSlug = null) =>
  BLOG_POSTS.filter((p) => p.meta.slug !== excludeSlug)
    .sort((a, b) => new Date(b.meta.date) - new Date(a.meta.date))
    .slice(0, limit);
